import { Children, type ReactNode } from 'react';

export interface SubregionLegendProps {
  /** The `SubregionPill`s the page chose to offer. */
  children?: ReactNode;
}

/** Lays out a row of sub-region pills for a calendar's filters slot. Draws nothing when empty. */
export function SubregionLegend({ children }: SubregionLegendProps) {
  if (Children.count(children) === 0) return null;
  return <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>{children}</div>;
}
